import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Location, ReleaseNote } from '../../models/user.model';
import { ReportCategory } from '../../models/report.model';

@Injectable()
export class LookupAdminService {
  endpoint = environment.apiEndpoint + '/LookupAdmin/';
  constructor(private http: HttpClient) {}

  GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
    //console.log(returnArry.length);

    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }

  getAllPosts$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllPosts').map((postList:Location[])=>postList);
  }
  getAllCountries$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllCountries').map((countryList:Location[])=>countryList);
  }
  getAllProgramAreas$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllProgramAreas').map((programAreaList:Location[])=>programAreaList);
  }

  getAllDivisions$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllDivisions').map((divisionList:Location[])=>divisionList);
  }


  savePost(post:Location)
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = post;
    return this.http.post(this.endpoint + '/SavePost', body, {
      headers,
      observe: 'response'
    });
  }
  
  saveCountry(country:Location)
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = country;
    return this.http.post(this.endpoint + '/SaveCountry', body, {
      headers,
      observe: 'response'
    });
  }

  saveProgramArea(programArea:Location)
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = programArea;
    return this.http.post(this.endpoint + '/SaveProgramArea', body, {
      headers,
      observe: 'response'
    });
  }


  saveDivision(division:Location)
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = division;
    return this.http.post(this.endpoint + '/SaveDivision', body, {
      headers,
      observe: 'response'
    });
  }

  saveReportCategory$(reportCategory:ReportCategory)
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportCategory;
    return this.http.post(this.endpoint + '/SaveReportCategory', body, {
      headers,
      observe: 'response'
    });
  }

  getAllReleaseNotes$():Observable<ReleaseNote[]>{
    return this.http.get(this.endpoint + 'GetAllReleaseNotes').map((releaseNoteList:ReleaseNote[])=>releaseNoteList);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/lookups/lookupadmin.service.ts